var _defs, _path, _polygon, _path2, _path3, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    "data-name": "Layer 2",
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.62,34A16.85,16.85,0,1,1,46.78,17.11"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "63.62 22.79 57.17 33.12 70.06 33.12 63.62 22.79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.09,34A28.07,28.07,0,0,1,63.34,58.67,8.35,8.35,0,0,0,58.88,66v4.07H41.12V66a8.35,8.35,0,0,0-4.46-7.33A28.09,28.09,0,1,1,78.09,34Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.66,70.07H64.34a0,0,0,0,1,0,0V79.8A14.34,14.34,0,0,1,50,94.14h0A14.34,14.34,0,0,1,35.66,79.8V70.07A0,0,0,0,1,35.66,70.07Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.66,
    x2: 64.34,
    y1: 78.09,
    y2: 78.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.c7622fe4057da6d7d07f9d5110f83689.svg";
export { ForwardRef as ReactComponent };